import type { FaireBrandEntity } from "../../entity_types/brand";

// Totally Bamboo — real Faire brand (b_2ni2ewzx8l). Metadata from
// ANALYTICS.CANONICAL.BRANDS. Used by the Totally Bamboo advertiser variant.
export const bTotallyBamboo: FaireBrandEntity = {
  token: "b_2ni2ewzx8l",
  type: "brand",
  name: "Totally Bamboo",
  description:
    "Masterfully crafted bamboo cutting boards, serveware, and gifts",
  location: "Escondido, CA",
  isTopShop: true,
  tags: ["home-decor", "kitchen-tabletop", "gifts"],
  meta: {
    source: "snowflake",
    importedAt: "2026-07-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
